// extracted by mini-css-extract-plugin
export default {"btn":"MealItemForm_btn__D1umz","form":"MealItemForm_form__U7cxK"};